import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate, CanActivateChild, CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';
import { defaultIfEmpty, filter, Observable, of, switchMap, take } from 'rxjs';
import {User} from "../../user/user.types";
import { StoreService } from '../../../ngrx/store.service';
import { Store } from '@ngrx/store';
import { selectConnectedUser } from '../../../ngrx/selectors/user.selectors';

@Injectable({
  providedIn: 'root'
})
export class CrmPartnerGuard implements CanActivate, CanActivateChild, CanLoad {

  constructor(  private readonly _router: Router,
                private readonly storeService:StoreService,
                private  store: Store) {
  }
  canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
    return this._check(redirectUrl);
    return true;
  }

  /**
   * Can activate child
   *
   * @param childRoute
   * @param state
   */
  canActivateChild(
      childRoute: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
    return this._check(redirectUrl);
  }

  /**
   * Can load
   *
   * @param route
   * @param segments
   */
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    const redirectUrl = route.path === 'sign-out' ? '/' : route.path;
    return this._check(redirectUrl);
  }

  private _check(redirectURL: string): Observable<boolean> {
    return this.store.select(selectConnectedUser).pipe(
      filter((curentUser) => curentUser !== undefined && curentUser !== null),
      take(1),
      switchMap((curentUser) => {
        if (curentUser?.hasCrmAccess) {
          return of(true);
        } else {
          console.log('CRM Forbidden access');
          this._router.navigateByUrl('/forbidden-access');
          return of(false);
        }
      })
    );
  }


  
}
